import { render, staticRenderFns } from "./RoutePeriodsOverview.vue?vue&type=template&id=10f41e0b&"
import script from "./RoutePeriodsOverview.vue?vue&type=script&lang=js&"
export * from "./RoutePeriodsOverview.vue?vue&type=script&lang=js&"
import style0 from "./RoutePeriodsOverview.vue?vue&type=style&index=0&id=10f41e0b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports